import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from '../Layout/Layout'
import LandingPage from '../Pages/LandingPage/LandingPage'
import Gallery from '../Pages/Gallery/Gallery'
const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<LandingPage />} />
        <Route path="gallery/:galleryName" element={<Gallery />} />
      </Route>
    </Routes>
  )
}

export default Router
